import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { Banner } from '@zen/DesignSystem';

interface Props {
  fileUrl: string;
}

const TextViewer: FC<Props> = ({ fileUrl }) => {
  const [textContent, setTextContent] = useState<string>('');
  const [hasErrors, setHasErrors] = useState<boolean>(false);

  const readTextFile = async (url: string): Promise<void> => {
    await fetch(url)
      .then((response: Response) => response.text())
      .then((textString: string) => {
        setTextContent(textString);
      })
      .catch((exception: DOMException) => {
        setHasErrors(true);
      });
  };

  useEffect(() => {
    readTextFile(fileUrl);
  }, []);

  const renderTextContent = (): ReactNode => {
    return textContent.split('\n').map(
      (textLine: string, index: number): ReactNode => (
        <div key={index}>
          {textLine}
          <br />
        </div>
      )
    );
  };

  const errorMessage: ReactNode = (
    <div className="max-w-lg">
      <Banner message="Error while fetching document and preview is not available" type="error" />
    </div>
  );

  return <div data-testid="text-file-reader">{!hasErrors ? renderTextContent() : errorMessage}</div>;
};

export default TextViewer;
